import React, { useState } from "react";
import FormInfoItem from "./FormInfoItem";
import { Field, Formik, useField } from "formik";
import Input from "../Payment/Input";
import { AddVillaRequestSheme } from "../../../validations/AddVillaRequestSheme";
import { useTranslation } from "../../../context/TranslationContext";
import PhoneInputW from "../../Reservation/PhoneInput";
import { SendAddVillaForm } from "../../api";
import { toast } from "react-toastify";
import { Dialog } from "@headlessui/react";

const Right = () => {
  const {
    name,
    surname,
    email,
    phone,
    sendBtnText,
    addVillaDestination,
    roomCount,
    poolType,
    advertiseQPre,
    advertiseQStrong,
    advertiseQPost,
    advertiseFormReceived,
    poolPrivate,
    poolShared,
    poolNone,
    seaViewLabel,
    yesLabel,
    noLabel,
    yourMessagePlaceholder,
    successTitle,
    closeBtn,
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState(advertiseFormReceived);

  const poolTypes = [
    // value: sunucuya giden (Turkce kalir, personel okur); text: ekranda gorunen
    { id: 1, value: "Özel Havuz", text: poolPrivate },
    { id: 2, value: "Ortak Havuz", text: poolShared },
    { id: 3, value: "Havuz Yok", text: poolNone },
  ];
  const HandleSubmit = (values, actions) => {
    SendAddVillaForm(values)
      .then((e) => {
        if (e.data.success) {
          setMessage(e.data.success);
          setIsOpen(true);
        } else {
          toast.error(e.data.error);
        }
      })
      .catch((e) => {
        toast.error(e.message);
      })
      .finally(() => {
        actions.setSubmitting(false);
        actions.resetForm();
      });
  };
  return (
    <div className="relative order-first w-full mt-3 lg:w-8/12 lg:ml-3 lg:mt-0 lg:order-last">
      <div className="p-5 bg-white border rounded-md shadow-xl lg:p-8">
        <span className="text-2xl text-brand-black text-light sm:text-3xl">
          {advertiseQPre}
          <strong className=" text-brand-blue">{advertiseQStrong}</strong>
          {advertiseQPost}
        </span>
        <Formik
          initialValues={{
            name: "",
            surname: "",
            phoneNumber: "",
            phoneNumberIsValid: false,
            email: "",
            destination: "",
            roomCount: "",
            poolType: [],
            seaView: "",
            message: "",
          }}
          validationSchema={AddVillaRequestSheme}
          onSubmit={HandleSubmit}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit}>
              <div className="grid gap-6 mt-5 mb-6 md:grid-cols-2 lg:mt-6">
                <div className="relative z-0 w-full p-1 group">
                  <Input name="name" placeholder=" " label={name} />
                </div>
                <div className="relative z-0 w-full p-1 group">
                  <Input name="surname" placeholder=" " label={surname} />
                </div>
                <div className="relative z-0 w-full group min-h-[70px] p-1">
                  <PhoneInputW
                    name="phoneNumber"
                    validname="phoneNumberIsValid"
                    label={phone}
                    mode={"simple"}
                    isrequired="required"
                  ></PhoneInputW>
                </div>
                <div className="relative z-0 w-full p-1 group">
                  <Input name="email" placeholder=" " label={email} />
                </div>
                <div className="relative z-0 w-full p-1 group">
                  <Input
                    name="destination"
                    placeholder=" "
                    label={addVillaDestination}
                  />
                </div>
                <div className="relative z-0 w-full p-1 group">
                  <Input name="roomCount" placeholder=" " label={roomCount} />
                </div>
              </div>
              <div
                className={`p-4 mb-6 border rounded-md ${
                  props.errors.poolType && props.touched.poolType
                    ? "border-red-500"
                    : ""
                }`}
              >
                <span className="block  mb-2 text-sm font-bold text-[#333738]">
                  {poolType}
                </span>
                <div className="flex flex-wrap items-center mt-3">
                  {poolTypes.map((item) => (
                    <CheckBoxItem
                      key={item.id}
                      id={item.id}
                      text={item.text}
                      value={item.value}
                    />
                  ))}
                </div>
              </div>
              <div
                className={`p-4 mb-6 border rounded-md ${
                  props.errors.seaView && props.touched.seaView
                    ? "border-red-500"
                    : ""
                }`}
              >
                <span className="block  mb-2 text-sm font-bold text-[#333738]">
                  {seaViewLabel}
                </span>
                <div className="flex items-center mt-3">
                  <div className="flex items-center mr-6 cursor-pointer">
                    <Field
                      type="radio"
                      name="seaView"
                      value="Var"
                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 "
                      id={`seaView_1`}
                    />
                    <label
                      htmlFor={`seaView_1`}
                      className="ml-2 text-xs font-light text-[#333738]"
                    >
                      {yesLabel}
                    </label>
                  </div>
                  <div className="flex items-center mr-6 cursor-pointer">
                    <Field
                      type="radio"
                      name="seaView"
                      value="Yok"
                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 "
                      id={`seaView_0`}
                    />
                    <label
                      htmlFor={`seaView_0`}
                      className="ml-2 text-xs font-light text-[#333738]"
                    >
                      {noLabel}
                    </label>
                  </div>
                </div>
              </div>
              <div className="mb-6">
                <Field
                  component="textarea"
                  name="message"
                  rows="4"
                  className="block p-2.5 w-full text-sm text-[#333738]  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                  placeholder={yourMessagePlaceholder}
                />
              </div>
              <div className="flex justify-end w-100">
                <button
                  type="submit"
                  disabled={props.isSubmitting}
                  className="text-white bg-brand-color-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center  disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {sendBtnText}
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        transition
        className="fixed z-50 inset-0 flex w-screen items-center justify-center bg-black/30 rounded-md p-4 transition duration-300 ease-out data-[closed]:opacity-0"
      >
        <Dialog.Panel className="max-w-lg p-8 space-y-4 bg-white rounded-md">
          <Dialog.Title className="font-bold">{successTitle}</Dialog.Title>
          <p>{message}</p>
          <div className="flex gap-4">
            <button
              className="p-2 text-sm text-white bg-red-400 rounded-md"
              onClick={() => setIsOpen(false)}
            >
              {closeBtn}
            </button>
          </div>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
};

export default Right;

const CheckBoxItem = ({ text, id, value }) => {
  return (
    <div className="flex items-center w-1/2 mb-4 mr-0 md:mr-6 md:mb-0 last:mr-0 md:w-auto">
      <Field
        type="checkbox"
        name="poolType"
        value={value}
        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        id={`poolType_checkbox_${id}`}
      />
      <label
        htmlFor={`poolType_checkbox_${id}`}
        className="ml-2 text-xs font-light text-[#333738]"
      >
        {text}
      </label>
    </div>
  );
};
